(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-step1
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Chip" :default Chip]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-full checkbox]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-true]]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    [reagent.core :as r]
    ))

(def VALIDATOR
  {:info_confirmed {:check-fn (check-true) :error-text "Bitte bestätigen" :missing-text "Zur Kenntnis genommen"}})

(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        form-valid (form-validator VALIDATOR !application)]
    [:> Grid {:container true}

     [grid-full [:> Typography {:variant "h3"} "1. Informationen zur Wallfahrt"]]
     [grid-full
      [:> Typography {:variant "h5"}]

      ]
     [grid-full
      [:> Typography {:variant "p"}
       "Hiermit melde ich mich für die " [:b "MALTESER Rom-Wallfahrt von 24. bis 31. Oktober 2026"] " an."
       [:br]
       "Ich nehme zur Kenntnis, dass aufgrund der hohen Nachfrage eine endgültige Teilnahme erst nach schriftlicher Bestätigung durch den MALTESER Hospitaldienst Austria (MHDA) gewährleistet ist."]

      [:br]
      [:br]

      [:> Typography {:variant "p"}
       "Die Teilnahme an der Reise erfolgt auf eigene Verantwortung. "
       "Die medizinische und pflegerische Betreuung wird während der Wallfahrt durch Mitglieder des MHDA sichergestellt. "
       "Es ist jedoch nicht möglich, auf alle denkbaren Notfälle vorbereitet zu sein. "]

      [:br]
      [:br]

      [:> Typography {:variant "p"}
       "Insbesondere übernimmt der MHDA " [:b "keine"] " Kosten für:"]
      [:ul
       [:li "ambulante oder stationäre Behandlungen in Krankenhäusern"]
       [:li "notwendige, ungeplante Rücktransporte"]
       ]
      [:> Typography {:variant "p"}


       "Sollte ein Rücktransport erforderlich sein und nicht von der Sozialversicherung oder einer privaten Reiseversicherung abgedeckt werden, verpflichte ich mich, die entstehenden Kosten selbst zu tragen."]

      [:br]
      [:br]

      [:> Typography {:variant "p"} "
   Bitte mitbringen:
   "]
      [:ul
       [:li "notwendige Medikamente"]
       [:li "persönliche Pflegeutensilien in ausreichender Menge (z.B. Schutzhosen, Harnbeutel, Netzhosen etc.)"]
       [:li "E-Card"]
       [:li "gültiges Reisedokument"]
       ]
      ]
     [grid-small]
     [grid-small
      [checkbox {:label      "Habe ich zur Kenntnis genommen"
                 :value      "info_confirmed"
                 :error      (:error (field-validator :info_confirmed))
                 :helperText (:helperText (field-validator :info_confirmed))
                 :checked    (:info_confirmed @!application)
                 :onChange   #(rf/dispatch [::application-events/store-value :info_confirmed %])
                 }]
      ]
     [grid-full
      ;[:pre (pr-str form-valid)]
      (when-not (:valid form-valid)
        (into [:<> "Es fehlen noch folgende Eingaben: "]
              (for [missing (:formMissingText form-valid)]
                [:> Chip {:label (str missing) :sx    {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
              ))
      ]
     ]))